export enum PractitionerStatus {
    PracticionerStatusCreated = 1,
    PracticionerStatusAccepted = 2,
    PracticionerStatusDeclined = 3,
}
